module.exports = __webpack_public_path__ + "img/mariadb-client.7ab566ab.svg";